import React, { Component } from "react";

export default class Title extends Component {
  render() {
    return (
      <section className="w-full bg-white py-16 px-4 sm:px-8 text-center animate__animated animate__fadeInUp">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">Our Mission</h2>
          <p className="text-lg sm:text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            Imaginex empowers small businesses and private clients to compete, scale, and thrive by providing accessible, innovative technology and strategic guidance. We believe technology should be a launchpad, not a barrier.
          </p>
        </div>
      </section>
    );
  }
}
